/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorFitnessChallengeTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorFitnessChallenge,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Fit Outdoors!",
    "Outdoor Fitness Challenge Awaits!",
    "Fitness Fun in the Sun!",
  ],
  title: "Outdoor Fitness Challenge",
  description: "Organize a fun outdoor fitness challenge.",
  longDescription:
    "Gather your friends for an exciting outdoor fitness challenge! Choose a date, decide on activities, and plan refreshments!",
  emoji: "🏋",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Fitness Challenge",
          emoji: "🏋",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the outdoor fitness challenge?",
          emoji: "📅",
          completeAction: {
            question: "Decide on fitness activities?",
            description:
              "What activities should we focus on during the challenge?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🏃",
                completeAction: {
                  question: "Decide on refreshments?",
                  description: "What refreshments should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Fit Together!",
    outroDescription:
      "Your outdoor fitness challenge plans are set! Enjoy the fun!",
  },
};
